import { Component, OnInit } from '@angular/core';
import {AhmService} from '../../services/ahm.service';

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.css']
})
export class HospitalComponent implements OnInit {

  constructor(private service: AhmService) { }

  alertMessage = '';

  ngOnInit() {
  }

  /**
   *
   */
  openPrivateHospital() {

    if ('eng' === this.service.version) {
      this.alertMessage = '<font szie="10" color="yellow"><< this module is under development. coming soon >></font>'
    } else if ('rus' === this.service.version) {
      this.alertMessage = '<font szie="10" color="yellow"><< данный модуль в разработке. ожидайте скоро >></font>'
    }

    setTimeout(() => { this.alertMessage = ''; }, 5000);

  }

}
